import React from "react";
import Slider from "react-slick";
import SinglePost from "../../components/Blog/SinglePost";

import blogImg3 from "../../assets/img/blog/style2/pr1.jpg";
import blogImg1 from "../../assets/img/blog/style2/pd1.jpg";
import blogImg2 from "../../assets/img/blog/style2/gr1.jpg";

const Androidblog = (props: any) => {
  const { Cardslice2 } = props;

  const blogSettings = {
    dots: false,
    centerMode: false,
    infinite: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <React.Fragment>
      <div className="container">
        <Slider {...blogSettings}>
          <SinglePost
            blogClass="blog-item"
            blogImage={
              Cardslice2
                ? Cardslice2?.body[1].items[0].cardimages.url
                : blogImg1
            }
            blogTitle={
              Cardslice2
                ? Cardslice2?.body[1].items[0].tittle[0].text
                : "Products Subscriptions"
            }
            blogDesc={
              Cardslice2
                ? Cardslice2?.body[1].items[0].subtittle[0].text
                : "You can monetize in the way that works best for your business—priced or free, with in-app products or subscriptions—for highest engagement and revenues. You also have complete control of the pricing for your apps and in-app products and can set or change prices in any supported currency at any time."
            }
          />
          <SinglePost
            blogClass="blog-item"
            blogImage={
              Cardslice2
                ? Cardslice2?.body[1].items[1].cardimages.url
                : blogImg2
            }
            blogTitle={
              Cardslice2
                ? Cardslice2?.body[1].items[1].tittle[0].text
                : "Growing Customer Base"
            }
            blogDesc={
              Cardslice2
                ? Cardslice2?.body[1].items[1].subtittle[0].text
                : "Beyond growing your customer base, Google Play helps you build visibility and engagement across your apps and brand. As your apps rise in popularity, Google Play gives them higher placement in weekly top charts and rankings, and for the best apps promotional slots in curated collections."
            }
          />
          <SinglePost
            blogClass="blog-item"
            blogImage={
              Cardslice2
                ? Cardslice2?.body[1].items[2].cardimages.url
                : blogImg3
            }
            blogTitle={
              Cardslice2
                ? Cardslice2?.body[1].items[2].tittle[0].text
                : "Premier Marketplace"
            }
            blogDesc={
              Cardslice2
                ? Cardslice2?.body[1].items[2].subtittle[0].text
                : "Google Play is the premier marketplace for selling and distributing Android apps. When you publish an app on Google Play, you reach the huge installed base of Android. Preinstalled on hundreds of millions of Android devices around the world, Google Play can be a growth engine for your business."
            }
          />
        </Slider>
      </div>
    </React.Fragment>
  );
};

export default Androidblog;
